import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { isNumeric } from 'rxjs/util/isNumeric';

const API_CONSULTASUBCOMPANIE = environment.API_CONSULTASUBCOMPANIE;
const API_DESACTIVESUBCOM = environment.API_DESACTIVESUBCOM;
const API_ACTIVESUBCOM = environment.API_ACTIVESUBCOM;
const API_CREATESUBCOM = environment.API_CREATESUBCOM;
const API_CONSULTASUBCOMPANIECI = environment.API_CONSULTASUBCOMPANIECI;
const API_UPDATESUBCOMPANY = environment.API_UPDATESUBCOMPANY;
const API_SUBCOMPANIEBYCOMPIE = environment.API_SUBCOMPANIEBYCOMPIE;
const API_CONSULTACOMPANIES = environment.API_CONSULTACOMPANIES;
const API_CONSDOCUMENEMP = environment.API_CONSDOCUMENEMP;

const API_GET_COMPANYBYRUC = environment.Global.API_GET_COMPANYBYRUC;
const API_CREATE_INTERCOMPANY = environment.Global.API_CREATE_INTERCOMPANY;
const API_GET_INTERCOMPANYBYID= environment.Global.API_GET_INTERCOMPANYBYID;

const API_GET_COMPANYBYID = environment.Global.API_GET_COMPANYBYID;
const API_ACTIVEINTERCOM = environment.Global.API_ACTIVEINTERCOM;
const API_INACTIVEINTERCOM = environment.Global.API_INACTIVEINTERCOM;

@Component({
  selector: 'app-regsubcontrac',
  templateUrl: './regsubcontrac.component.html',
  styleUrls: ['./regsubcontrac.component.css']
})
export class RegsubcontracComponent extends BaseCrudComponent {
  selectedTab:any;
  Company: any;
  id:any;
  loadingRequired = false;
  listAgr:any;
  translations:any;
  userinfo:any;
  jobtypeID:any;
  mostarselectemp = true;
  pageSizeic = 10;
  date;
  CompanyID;
  seleccionados=[];
  SubContratista = "SubContratista";
  curr_cur:any;
  listcomp:any;

  constructor(
    srv: ApiService,
    modalService: NgbModal,
    storage: Storage,
    router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService
  ) {
    super(srv, modalService, storage, router);
        this.id = route.snapshot.params.id;

        this.read_url = API_CONSULTASUBCOMPANIE;
        this.delete_url = API_DESACTIVESUBCOM;
        this.active_url = API_ACTIVESUBCOM;
        this.create_url = API_CREATESUBCOM;
        this.select_url = API_CONSULTASUBCOMPANIECI;
        this.update_url = API_UPDATESUBCOMPANY;
        this.read_url_byID = API_SUBCOMPANIEBYCOMPIE;
        this.urlemp = API_CONSULTACOMPANIES;
        this.documentemp_url = API_CONSDOCUMENEMP;

        this.search_fields = ['Name', 'Ruc', 'NameCompany'];

        this.c_obj['SubCompany'] = [];

        this.reload.subscribe(val => {
          if( val ){
            super.clearData();
          }
        });
   }

   ngOnInit() {
    this.date = new Date();
    this.translate.getTranslation(this.translate.currentLang)
    .subscribe((translations) => {
          this.translations = translations;
          super.ngOnInit();
    });
    this.userinfo = [];
    this.userinfo['name'] = '';
    this.userinfo['emailAddress'] = '';
    this.storage.get('userinfo').then(x => {
      this.userinfo = x;
      if( isNumeric( this.userinfo.logon) ) {
        this.mostarselectemp = false;
        this.getList();
      } else {
        this.mostarselectemp = true;
      }
    });
  }

  private async fetchCompaniesByIds(companyIds: number[]): Promise<any[]> {
    const companyPromises = companyIds.map(id => this.srv.getCall(API_GET_COMPANYBYID + id).toPromise());
    try {
      const results = await Promise.all(companyPromises);
      // Filtrar las respuestas exitosas y extraer las compañías
      return results
        .filter(x => x.success && x.val != null) // Filtra las respuestas con éxito
        .map(x => x.val[0]); // Extrae la compañía (asumiendo que está en la posición 0)
    } catch (error) {
      console.error("Error fetching companies:", error);
      Swal.fire("Error fetching company details", '', 'error');
      return [];
    }
  }

  private async fetchSubCompaniesByIds(subCompanyIds: number[]): Promise<any[]> {
    const subCompanyPromises = subCompanyIds.map(id => this.srv.getCall("CompaniesConsulta/SubCompanyByID/" + id).toPromise());
    try {
      const results = await Promise.all(subCompanyPromises);
      // Filtrar las respuestas exitosas y extraer las subcompañías
      return results
        .filter(x => x.success && x.val != null) // Filtra las respuestas con éxito
        .map(x => x.val[0]); // Extrae la subcompañía (asumiendo que está en la posición 0)
    } catch (error) {
      console.error("Error fetching subcompanies:", error);
      Swal.fire("Error fetching subcompany details", '', 'error');
      return [];
    }
  }

  public async searchInterCompany(){
    await this.srv.getCall(API_GET_INTERCOMPANYBYID + this.userinfo['userId']).toPromise().then(async x => {
      if(x.success){
        if(x.val != null){
           this.rsic = x.val;debugger;
          console.log('rrtt', this.rsic)

          // Obtener los IDs de las compañías hijas
          const companyIds = this.rsic.map((item: any) => item.CompanyIdChild).filter(id => id != null);
          // Obtener los IDs de las subcompañías hijas
          const subCompanyIds = this.rsic.map((item: any) => item.SubCompanyIdChild).filter(id => id != null);
          console.log('subCompanyIds', subCompanyIds)

          // Llamar a los métodos para buscar compañías y subcompañías
          const fetchedCompanies = await this.fetchCompaniesByIds(companyIds);
          const fetchedSubCompanies = await this.fetchSubCompaniesByIds(subCompanyIds);
          //console.log('fetchedSubCompanies', fetchedSubCompanies)

          // Combinar los datos con el campo IsActive desde rsic
          this.rowsic = [
            ...fetchedCompanies.map(company => {
              const matchingRsic = this.rsic.find((item: any) => item.CompanyIdChild === company.CompanyID);
              return {
                ...company,
                IsActive: matchingRsic ? matchingRsic.IsActive : null,
                InterCompanyId: matchingRsic ? matchingRsic.InterCompanyId : null,
              };
            }),
            ...fetchedSubCompanies.map(subCompany => {
              const matchingRsic = this.rsic.find((item: any) => item.SubCompanyIdChild === subCompany.SubCompanyID);
              return {
                ...subCompany,
                IsActive: matchingRsic ? matchingRsic.IsActive : null,
                InterCompanyId: matchingRsic ? matchingRsic.InterCompanyId : null,
              };
            }),
          ];

          //console.log('rr', this.rowsic)

          this.pageic = 1;
          if( Array.isArray(this.rowsic) ){
            this.pageTotalic = this.rowsic.length;
          }

        } else {
          //this.rowsic = [];
        }
      }else {
        //this.rowsic = [];
        Swal.fire(x.msg, '', 'error');
        return;
      }
    });
  }

  public getList() {
    this.searchInterCompany();
    ////debugger;
    var qst = this.read_url+"/"+this.userinfo['logon'];
    this.loadingList = true;
    this.srv.getCall(qst).subscribe(x => {
      this.loadingList = false;
      if(x.success){
        if(x.val != null){
          this.rawdata = x.val;
          var rs = x.val;
          this.rows = rs;
          this.page = 1;
          if( Array.isArray(this.rows) ){
             this.pageTotal = this.rows.length;
          }
          this.filterAll();
          Swal.close()
        }else {
          Swal.fire(this.translations.empty, this.translations.not_registers, 'success');
          this.rows = [];
          return;
        }
      }else {
        Swal.fire(x.msg, '', 'error');
        return;
      }
  });
}

  public getListEmp(){
    var qst = "CompaniesConsulta/CompanyById";
    qst=qst+"/"+this.userinfo['selectedCompanyId'];
    this.srv.getCall(qst).subscribe(x => {
      // //debugger;
      this.loadingList = false;

      if(x.success){
          var rs = x.val;
          this.rowemp = rs;
      }else {
          Swal.fire(x.msg, '', 'success');
        return;
      }
    });
  }

  consultaSubEmp (form:any){
    if ((form.Ruc != undefined) || (form.Ruc != '')) {
      var qst = this.select_url;
      var id:any;
      id = {};
      id.Ruc = form.Ruc;
      this.srv.postCall3(qst, id).subscribe(x => {
        this.isCreating = false;
        Swal.close();
        if (x.success) {
          console.log("asas", x);
          // Llenar los campos con la respuesta de x.val
          this.c_obj['Name'] = x.val[0].Name || '';  // Asumiendo que 'Name' es uno de los campos en x.val
          this.c_obj['Ruc'] = x.val[0].Ruc || '';
          this.c_obj['Email'] = x.val[0].Email || '';
          this.c_obj['LegalName'] = x.val[0].LegalName ? x.val[0].LegalName || '' : x.val[0].legalrepresentative || '';
          this.c_obj['SecurityName'] = x.val[0].SecurityName ? x.val[0].SecurityName || '' : x.val[0].securityrepresentative || '';
          this.c_obj['LegalCI'] = x.val[0].LegalCI ? x.val[0].LegalCI || '' : x.val[0].legalidentification || '';
          this.c_obj['SecurityCI'] = x.val[0].SecurityCI ? x.val[0].SecurityCI || '' : x.val[0].securityidentification || '';
          this.c_obj['legalEmail'] = x.val[0].legalEmail ? x.val[0].legalEmail || '' : x.val[0].legalmail || '';
          this.c_obj['SecurityEmail'] = x.val[0].SecurityEmail ? x.val[0].SecurityEmail || '' : x.val[0].securitymail || '';
          Swal.fire({
            title: this.translations.ruc_exist,
            text: x.msg ,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#005c3c',
            confirmButtonText: this.translations.accept,
            allowOutsideClick: () => Swal.isLoading(),
          }).then((result) => {
            if (result.value) {
              //this.getList();
              //this.closeModal('create1');
            }
          })
        } else{
          return;
        }
      }, err => {
        Swal.close();
        Swal.fire('Error');
      });

    }
  }


   public async createItem(content:any, form:any){debugger;
    ////debugger;
     //console.log('tt',this.userinfo)
    var validated = true;

    if( form == undefined ){
      form = {};
    }
    const loggedInRuc = this.userinfo['logon'];

    validated = this.validateCreateInfo(form);
    if( !validated ){
        Swal.fire(this.translations['msg_all_required'], '', 'error');
        return;
    }
     // Verificar que el RUC no sea igual al de la empresa logoneada
     if (form.Ruc == loggedInRuc) {
       Swal.fire('El RUC del subcontratista no puede ser igual al de la empresa logoneada.', '', 'error');
       return;
     }else if (this.rawdata.length > 0) {
       //console.log("sssssss",this.rawdata);

       //Verificar si el ruc pertenece a la empresa
       const matchingSubCompanies = this.rawdata.filter((subCompany: any) =>
         subCompany.Ruc === form.Ruc
       );

       if (matchingSubCompanies.length > 0) {
         console.log("aaaaaa",matchingSubCompanies);
         // Aquí puedes manejar el caso cuando hay coincidencias
         Swal.fire('El subcontratista ya pertenece a la empresa logoneada.', '', 'error');
          //return;
       } else {

       }

     }
      //revisar si existe el ruc de la compañia
     await this.srv.getCall3(API_GET_COMPANYBYRUC + form.Ruc).toPromise().then(x => {debugger;
       if(x.success){
         if(x.val != null){
           this.Company = x.val[0];debugger;
           if(this.Company.SubCompanyID){
             var SubCompanyId = this.Company.SubCompanyID;
             var CompanyId2 = 0;
           }else{
             CompanyId2 = this.Company.CompanyID;
             SubCompanyId = 0;
           }


           Swal.fire({
             title: 'El RUC ya existe',
             text: '¿Desea crear una relación?',
             icon: 'warning',
             showCancelButton: true,
             confirmButtonText: 'Sí, crear',
             cancelButtonText: 'No, cancelar'
           }).then((result) => {
             if (result.value) {debugger;
               // Acción cuando el usuario hace clic en "Sí, crear"
               const CompanyId1 = this.userinfo['userId'];
               //const CompanyId2 = this.Company.CompanyID;
               const qst = `CompaniesConsulta/InterCompanyCreate/${CompanyId1}/${CompanyId2}/${SubCompanyId}`;debugger;
               this.srv.postCall(qst, {}).subscribe(x => {
                 this.isCreating = false;
                 if(x.success){
                   this.closeModal(content);
                   Swal.fire(this.translations.msg_create, x.msg, 'success');
                   this.getList();
                 }//end success
                 else{
                   Swal.fire('Error', x.msg, 'error');debugger;
                   return;
                 }
               });

             } else if (result.dismiss === Swal.DismissReason.cancel) {
               // Acción cuando el usuario hace clic en "No, cancelar" (opcional)
               //console.log('El usuario canceló la operación.');
             }
           });

         } else {
           this.Company = [];
           return;
         }
       }else {
         var to:any;
         //to.CompanyID=this.userinfo.selectedCompanyId;
         form.CompanyID = this.userinfo.selectedCompanyId;//form.empselect.CompanyID;
         form.CreatorUser = this.userinfo['logon'];
         form.LastModifierUser = this.userinfo['userId'];
         to = form;


         var qst = this.create_url;
         this.isCreating = true;

         this.srv.postCall(qst, to).subscribe(x => {debugger;
           this.isCreating = false;
           if(x.success){
             this.getList();
             this.closeModal(content);
             Swal.fire(this.translations.msg_create, x.msg, 'success');
           }//end success
           else{
             Swal.fire(x.msg, '', 'error');
           }
         });
       }
     });

     // this.searchCompanyByRuc(form);
     // if (this.Company.count !== 0 ){
     //   Swal.fire('El RUC ya existe desea crear una relacion?', '', 'error');
     //   return;
     // } else{
     //   Swal.fire('El RUC ya existe', '', 'error');
     //   return;
     // }


  }


   validateCreateInfo(fields:any){
    let mygroup:any = {};
    mygroup = new FormGroup({
        'Name': new FormControl(fields.Name, [Validators.required]),
        'Ruc': new FormControl(fields.Ruc, [Validators.required]),
        'Email': new FormControl(fields.Email, [Validators.required]),
        'LegalName': new FormControl(fields.LegalName, [Validators.required]),
        'LegalCI': new FormControl(fields.LegalCI, [Validators.required]),
        'legalEmail': new FormControl(fields.legalEmail, [Validators.required]),
        'SecurityName': new FormControl(fields.SecurityName, [Validators.required]),
        'SecurityCI': new FormControl(fields.SecurityCI, [Validators.required]),
        'SecurityEmail': new FormControl(fields.SecurityEmail, [Validators.required]),
    });

    return mygroup.valid;
  }

  public filterAnalysisGroup(id:any){
    ////debugger;
    this.CompanyID = id.split(':')[1].trim();

  }



  public updateItem(content:any, form:any){
  // //debugger;
   this.isCreating = true;
   var qst = this.update_url;

   if( form == undefined ){
     form = {};
   }

   var to:any;

   if( (form.Name == undefined) || (form.Name == '') ){
       Swal.fire(this.translations.msg_all_required, 'msg', 'warning');
       return;
   }

   to = {};
   to.Ruc = form.Ruc;
   to.Name = form.Name;
   to.CompanyID =  this.CompanyID;
   to.Email = form.Email;
   to.LegalName = form.LegalName;
   to.LegalCI = form.LegalCI;
   to.legalEmail = form.legalEmail;
   to.SecurityName = form.SecurityName;
   to.SecurityCI = form.SecurityCI;
   to.SecurityEmail = form.SecurityEmail;
   to.LastModifierUserID = this.userinfo['userId'];
   to.CompanyID=this.userinfo['selectedCompanyId'];
   to.SubCompanyID = form.SubCompanyID;


   this.srv.postCall(qst, to).subscribe(x => {
     this.isCreating = false;
     Swal.close();
     if (x.success) {
       this.reload.next(true);
       this.closeModal('update1');
       Swal.fire(this.translations.msg_update, x.msg, 'success');
       this.getList();

     }
  }, err => {
     Swal.close();
     Swal.fire('Error');
    });

 }

 deleteItem(obj: any){
  var id:any;
  id = {};
  id.SubCompanyID = obj;
  var qst = this.delete_url;
  this.srv.postCall(qst, id).subscribe(x => {
    this.isCreating = false;
    Swal.close();
    if(x.success){
      this.reload.next(true);
      Swal.fire('Desactivado!', x.msg, 'success');
      this.getList();
  }
  else{
      Swal.fire(x.msg, '', 'error');
  }
 }, err => {
    Swal.close();
    Swal.fire('Error');
   });
}


Activar(obj: any){
  var id:any;
  id = {};
  id.SubCompanyID = obj;
  var qst = this.active_url;
  this.srv.postCall(qst, id).subscribe(x => {
    this.isCreating = false;
    Swal.close();
    if(x.success){
      this.reload.next(true);
      Swal.fire('¡Activado!', x.msg, 'success');
      this.getList();
  }
  else{
      Swal.fire(x.msg, '', 'error');
  }
 }, err => {
    Swal.close();
    Swal.fire('Error');
   });
}

toggleEditable(event, id) {
  if ( event.target.checked ) {
     this.Activar(id);
 }else {
   this.deleteItem(id);

}
}

  toggleEditableic(event, id) {
    if ( event.target.checked ) {
      this.Activaric(id);
    }else {
      this.deleteItemic(id);

    }
  }

  Activaric(obj: any){debugger;
    var id:any;
    id = {};
    id.InterCompanyId = obj;
    var qst = API_ACTIVEINTERCOM;
    this.srv.postCall(qst, id).subscribe(x => {
      this.isCreating = false;
      Swal.close();
      if(x.success){
        this.reload.next(true);
        Swal.fire({
          title: 'Activado!',
          text: x.msg,
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => {
          // Este código se ejecutará después de que el usuario haga clic en OK
          this.getList();
        });
      }
      else{
        Swal.fire(x.msg, '', 'error');
      }
    }, err => {
      Swal.close();
      Swal.fire('Error');
    });
  }

  deleteItemic(obj: any){
    var id:any;
    id = {};
    id.InterCompanyId = obj;
    var qst = API_INACTIVEINTERCOM;
    this.srv.postCall(qst, id).subscribe(x => {
      this.isCreating = false;
      Swal.close();
      if(x.success){
        this.reload.next(true);
        Swal.fire({
          title: 'Desactivado!',
          text: x.msg,
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => {
          // Este código se ejecutará después de que el usuario haga clic en OK
          this.getList();
        });
      }
      else{
        Swal.fire(x.msg, '', 'error');
      }
    }, err => {
      Swal.close();
      Swal.fire('Error');
    });
  }

onlyNumberKey(event) {
  return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
}


public openCreateModal(content: any) {
  this.c_obj = {};

  //this.modalService.open(content, { size: 'lg' });
  this.modalService.open(content, { backdrop: 'static', keyboard: false ,size:'lg'});
}


}
